import React from 'react';
import {Control, ErrorComponent, Checkbox} from 'MWComponents';
import '../less';
import smile_img from '../img/smile.png';
import css from '../../Express/less/form/form.m.less';

export default function template() {
    const model = this.getModel(),
        {simpleMode, attribute} = this.props,

        {customerName, contactPhoneNumber, agree, adress, companyName} = model.fields,
        form = (
            <>
                <div className="title" dangerouslySetInnerHTML={{__html: simpleMode ? this.l10n('SEND_CARD_BUTTON_SEND_TITLE') : this.l10n('BUSINESS_ORDER_MODAL_TITLE')}}></div>
                <div className="send-form">
                  { !simpleMode ?
                  <div className="send-form__item">
                    <input
                      type="text"
                      className={`custom-input ${
                        !customerName.isValid && !customerName.firstInput ? 'red-color' : ''
                      }`}
                      name="customerName"
                      value={customerName.value}
                      onChange={this.handleChange}
                      placeholder={this.l10n('BUSINESS_GUARANTEES_LABEL_1')}
                      onBlur={() => this.onBlurHandle('customerName')}
                      maxLength={100}
                      autoComplete="off"
                    />

                    <div className="error">
                      <div
                        className={`error__message ${
                          customerName.errors.length && !customerName.firstInput
                            ? 'active'
                            : ''
                        }`}
                      >
                        {this.l10n(customerName.errors.join('.'))}
                      </div>
                    </div>
                  </div>
                  : ''
                  }

                    <div className="send-form__item">
                        <input
                            type="text"
                            className={`custom-input ${
                                !contactPhoneNumber.isValid && !contactPhoneNumber.firstInput
                                    ? 'red-color'
                                    : ''
                            }`}
                            name="contactPhoneNumber"
                            value={contactPhoneNumber.value}
                            onChange={this.handleChange}
                            placeholder={this.l10n('BUSINESS_GUARANTEES_LABEL_2')}
                            onBlur={() => this.onBlurHandle('contactPhoneNumber')}
                            maxLength={20}
                            autoComplete="off"
                        />

                        <div className="error">
                            <div
                                className={`error__message ${
                                    contactPhoneNumber.errors.length &&
                                    !contactPhoneNumber.firstInput
                                        ? 'active'
                                        : ''
                                }`}
                            >
                                {this.l10n(contactPhoneNumber.errors.join('.'))}
                            </div>
                        </div>
                    </div>
                  {attribute === 'tso' ?
                    <div className="send-form__item">
                      <input
                        type="text"
                        className={`custom-input ${
                          !adress.isValid && !adress.firstInput
                            ? 'red-color'
                            : ''
                        }`}
                        name="adress"
                        value={adress.value}
                        onChange={this.handleChange}
                        placeholder={this.l10n('BUSINESS_GUARANTEES_LABEL_5')}
                        onBlur={() => this.onBlurHandle('adress')}
                        maxLength={100}
                        autoComplete="off"
                      />

                      <div className="error">
                        <div
                          className={`error__message ${
                            adress.errors.length &&
                            !adress.firstInput
                              ? 'active'
                              : ''
                          }`}
                        >
                          {this.l10n(adress.errors.join('.'))}
                        </div>
                      </div>
                    </div>
                    :
                    ''
                  }
                  {attribute === 'tso' ?
                    <div className="send-form__item">
                      <input
                        type="text"
                        className={`custom-input ${
                          !companyName.isValid && !companyName.firstInput
                            ? 'red-color'
                            : ''
                        }`}
                        name="companyName"
                        value={companyName.value}
                        onChange={this.handleChange}
                        placeholder={this.l10n('BUSINESS_GUARANTEES_LABEL_6')}
                        onBlur={() => this.onBlurHandle('companyName')}
                        maxLength={100}
                        autoComplete="off"
                      />

                      <div className="error">
                        <div
                          className={`error__message ${
                            companyName.errors.length &&
                            !companyName.firstInput
                              ? 'active'
                              : ''
                          }`}
                        >
                          {this.l10n(companyName.errors.join('.'))}
                        </div>
                      </div>
                    </div>
                    :
                    ''
                  }
                </div>
              {!simpleMode ?
                <div className="i-agree-block">
                  <Checkbox
                    checked={agree.value}
                    onChange={e => this.selectItem('agree')}
                    className="checkbox-agree"
                  >
                        <span>
                            {this.l10n('BUSINESS_GUARANTEES_AGREE_1')}{' '}
                          {this.l10n('BUSINESS_GUARANTEES_AGREE_2')}
                        </span>
                  </Checkbox>
                </div>
                : ''
              }
              {
                !simpleMode ?
                  <div className="button-wrapper">
                    <button
                      className="button button-order"
                      onClick={attribute === 'tso' ? () => this.sendTsoForm() : this.sendForm}
                      disabled={!model.isValid}
                    >
                      {this.l10n('BUSINESS_ORDER_MODAL_SEND')}
                    </button>
                  </div>
                  :
                  <div className="button-wrapper">
                    <button
                      className="button button-order"
                      onClick={this.sendSimpleForm}
                    >
                      {this.l10n('SEND_CARD_BUTTON_SEND_TEXT')}
                    </button>
                  </div>
              }

            </>
        ),
        success = (
            <>
                <div className='success' style={{marginTop: '20px'}}>
                    <div className='success-title' >{this.l10n('BUSINESS_ORDER_RESULT_TITLE')} <img src={smile_img} alt="smile_img" /></div>
                    <div className='success-subtitle' dangerouslySetInnerHTML={{__html: simpleMode ? this.l10n('SHOPING_ATB_MODAL_TEXT') : this.l10n('BUSINESS_ORDER_RESULT_SUBTITLE')}}></div>
                    <button className='ok-btn' onClick={() => this.props.closeModal()}>{this.l10n('BUSINESS_ORDER_RESULT_BTN')}</button>
                </div>
            </>
        ),
        error = (
            <Control className="control" style={{marginTop: '30px'}}>
                <ErrorComponent type="form">
                    {this.l10n('GREEN_CARD_ORDER_ERROR_TEXT')}
                </ErrorComponent>
            </Control>
        ),
        screens = {
            form,
            success,
            error,
        };

    return (
        <div className="form-wrapper" onClick={this.closeModal}>
            <div className="form-container">
                <div className="close-btn" onClick={() => this.props.closeModal()} />
                {screens[this.state.activeScreen]}
            </div>
        </div>
    );
}
